/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Close as CloseIcon } from "@mui/icons-material";
import { IconButton } from "@mui/material";

const CloseButton = (props) => {
    
    const { closeHandler } = props; 

    return (
        <IconButton
            aria-label='close'
            onClick={closeHandler}
            sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
            }}
        >
            <CloseIcon />
        </IconButton>
    );
};

CloseButton.displayName = "CloseButton";
export { CloseButton };
